__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@fsa/command-center";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@asurion-core/mx-asurion-ui-react", "4.64.10", () => (__webpack_require__.e(26).then(() => (() => (__webpack_require__(22026))))));
			register("@sbx/sbx-deimos-reactui-common", "6.2.9", () => (__webpack_require__.e(489).then(() => (() => (__webpack_require__(98489))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(41475))), 1);
			register("react-redux", "7.2.9", () => (() => (__webpack_require__(82784))), 1);
			register("react-redux", "8.1.3", () => (() => (__webpack_require__(55914))), 1);
			register("react-redux", "9.3.0", () => (() => (__webpack_require__(71468))), 1);
			register("react-router-dom", "7.18.4", () => (() => (__webpack_require__(70118))), 1);
			register("react/jsx-runtime", "18.3.1", () => (() => (__webpack_require__(41290))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(51810))), 1);
			initExternal(96991);
			initExternal(53284);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};